/* Shared initializer for the existing Powerpay popup, including theme-editor reloads. */
if (!window.initScooterlandPowerpay) {
  window.initScooterlandPowerpay = (container = document) => {
    container.querySelectorAll("[data-pp-root]").forEach((root) => {
      if (root.dataset.ppBound) return;
      const modal = root.nextElementSibling;
      if (!modal?.classList.contains("pp-modal")) return;
      root.dataset.ppBound = "1";
      const abort = new AbortController();
      const on = (node, type, handler) =>
        node.addEventListener(type, handler, { signal: abort.signal });
      const iframe = modal.querySelector("[data-pp-iframe]");
      const loading = modal.querySelector("[data-pp-loading]");
      const trigger = root.querySelector("[data-pp-trigger]");
      const variants = JSON.parse(
        root.querySelector("[data-pp-variants]").textContent,
      );
      const moneyFormat =
        window.MinimogSettings?.money_format || "S/{{amount}}";
      document.body.append(modal);
      let restoreOverflow = "",
        closeTimer;
      const formatMoney = (cents) => {
        const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!match) return moneyFormat;
        const parts = (cents / 100)
          .toFixed(match[1].includes("no_decimals") ? 0 : 2)
          .split(".");
        const comma = match[1].includes("comma_separator");
        const value =
          parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + (comma ? "." : ","),
          ) + (parts[1] ? (comma ? "," : ".") + parts[1] : "");
        return moneyFormat.replace(match[0], value);
      };
      const url = () =>
        "https://widget.powerpay.pe/?clientId=" +
        encodeURIComponent(root.dataset.clientId) +
        "&price=" +
        encodeURIComponent(root.dataset.price) +
        "&theme=";
      const close = () => {
        if (!modal.classList.contains("is-active")) return;
        modal.classList.remove("is-active");
        modal.setAttribute("aria-hidden", "true");
        document.body.style.overflow = restoreOverflow;
        trigger.focus();
        closeTimer = setTimeout(() => {
          iframe.src = "";
          loading?.classList.remove("is-hidden");
        }, 300);
      };
      on(trigger, "click", () => {
        clearTimeout(closeTimer);
        restoreOverflow = document.body.style.overflow;
        loading?.classList.remove("is-hidden");
        iframe.src = url();
        modal.classList.add("is-active");
        modal.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        modal.querySelector("button[data-pp-close]").focus();
      });
      modal
        .querySelectorAll("[data-pp-close]")
        .forEach((button) => on(button, "click", close));
      on(iframe, "load", () => {
        if (iframe.getAttribute("src")) loading?.classList.add("is-hidden");
      });
      on(document, "keydown", (event) => {
        if (!modal.classList.contains("is-active")) return;
        if (event.key === "Escape") close();
        if (event.key === "Tab") {
          const focusable = [...modal.querySelectorAll("button,iframe")];
          if (event.shiftKey && document.activeElement === focusable[0]) {
            event.preventDefault();
            focusable.at(-1).focus();
          } else if (
            !event.shiftKey &&
            document.activeElement === focusable.at(-1)
          ) {
            event.preventDefault();
            focusable[0].focus();
          }
        }
      });
      on(document, "variant:changed", (event) => {
        const selected = event.detail?.variant;
        const id = selected?.id || event.detail?.id;
        const variant = variants.find((v) => String(v.id) === String(id));
        if (!variant) return;
        root.dataset.price = (variant.price / 100).toFixed(2);
        const cap = Number(root.dataset.cuotasMaxCents) || 0;
        const promoCuotas = Number(root.dataset.cuotasPromo) || 0;
        const baseCuotas = Number(root.dataset.cuotasBase) || 0;
        const cuotas =
          cap && variant.price > cap
            ? baseCuotas || Number(root.dataset.cuotas) || 1
            : promoCuotas || Number(root.dataset.cuotas) || 1;
        root.dataset.cuotas = String(cuotas);
        const cuotasEl = root.querySelector("[data-pp-cuotas]");
        if (cuotasEl) cuotasEl.textContent = String(cuotas);
        const monthly = Math.round(
          (variant.price * (Number(root.dataset.factor) || 10000)) /
            10000 /
            cuotas,
        );
        root.querySelector("[data-pp-monthly]").textContent =
          formatMoney(monthly);
        if (modal.classList.contains("is-active")) iframe.src = url();
      });
      on(root, "pp:dispose", () => {
        if (modal.classList.contains("is-active"))
          document.body.style.overflow = restoreOverflow;
        clearTimeout(closeTimer);
        abort.abort();
        modal.remove();
        delete root.dataset.ppBound;
      });
    });
  };
  document.addEventListener("shopify:section:load", (event) =>
    window.initScooterlandPowerpay(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) =>
    event.target
      .querySelectorAll("[data-pp-root]")
      .forEach((root) => root.dispatchEvent(new Event("pp:dispose"))),
  );
}
window.initScooterlandPowerpay();
